import { BaseModel } from "../../../vendor_core/core/src/model/BaseModel";

class BURPaytableModel extends BaseModel<{}> {
    private sizeBuckets: string[] = [];
    private symbolsMap = new Map<number, string>([
        [1, "wr"],
        [2, "h1"],
        [3, "h2"],
        [4, "m3"],
        [5, "m4"],
        [6, "m5"],
        [7, "m6"],
        [8, "a"],
        [9, "k"],
        [10, "q"],
        [11, "j"]
    ]);

    private symbolPayouts: Map<number, number[]> = new Map();

    public get size_buckets() {
        return this.sizeBuckets;
    }

    public get symbols() {
        return this.symbolsMap;
    }

    public get symbol_payouts() {
        return this.symbolPayouts;
    }

    public setSizeBuckets(payload: string[]) {
        this.sizeBuckets = payload;
    }

    public setSymbolPayouts(id: number, payouts: number[]) {
        this.symbolPayouts.set(id, payouts);
    }
}

export default new BURPaytableModel();
